import { useOrderBumbalData } from "app/hooks/appointment/useOrderBumbalData";
import { useAvailableBumbalDates } from "app/hooks/checkout/useAvailableBumbalDates";
import { useOrderContext } from "app/providers/OrderProvider";
import { useEffect, useMemo, useState } from "react";
import Card from "shared/ui/card";
import Container from "shared/ui/container";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import Bumbal from "widgets/shared/bumbal";

interface NoAppointmentProps {
  setHasAppointment: React.Dispatch<React.SetStateAction<boolean>>;
  selectedDate: Date | null;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
}
const NoAppointment = ({
  setHasAppointment,
  selectedDate,
  setSelectedDate,
}: NoAppointmentProps) => {
  const { isOrderFetching, orderError, order, type } = useOrderContext();
  const {
    setPageMonth,
    setPageYear,
    isBumbalDataFetching,
    isBumbalDataLoading,
    bumbalDates,
    bumbalData,
    fetchAmount,
  } = useAvailableBumbalDates();

  const APPOINTMENT_TYPES: Record<
    string,
    { title: string; description: string }
  > = useMemo(
    () => ({
      measurement: {
        title: "Plan je gratis inmeetafspraak",
        description:
          "Leuk dat onze inmeter bij je langs mag komen voor gratis inmeten en advies. Kies in de kalender jouw gewenste datum.",
      },
      placement: {
        title: "Maak hier je afspraak voor montage",
        description: `Binnenkort komen we je bestelling met referentienummer ${order?.orderNumber} leveren en installeren. Kies hier een datum waarop wij dat mogen komen doen.`,
      },
      shipment: {
        title: "Maak direct je afleverafspraak",
        description:
          "Wij komen je bestelling graag bij je leveren. Kies hier de gewenste datum waarop wij langskomen.",
      },
    }),
    [order?.orderNumber]
  );

  const [inputType, setInputType] = useState<string>("hover");

  const fetchDates = (month: number, year: number, type: string) => {
    setPageMonth(month);
    setPageYear(year);
    setInputType(type);
  };

  return (
    <Container>
      <Card className="gg-py-14 gg-px-4 sm:gg-px-14 2xl:gg-px-24">
        <div className="gg-grid gg-grid-cols-12">
          <div className="gg-col-span-12 gg-mb-10 lg:gg-mb-0 lg:gg-col-span-4 lg:gg-pr-10 xl:gg-pr-24">
            <Heading headingLevel={"h2"} className="gg-mb-5">
              {APPOINTMENT_TYPES[type].title}
            </Heading>

            <Text className="gg-mb-4">
              {APPOINTMENT_TYPES[type].description}
            </Text>

            {!isOrderFetching && !orderError && !!order && (
              <Text>Referentienummer: {order?.orderNumber}</Text>
            )}
          </div>

          <div className="gg-col-span-12 lg:gg-col-span-8">
            {!isBumbalDataLoading ? (
              isBumbalDataFetching ? (
                inputType === "click" ? (
                  <>
                    {bumbalData && (
                      <Bumbal
                        refetchDates={() => {}}
                        slots={[]}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        refetchAmount={fetchAmount}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {bumbalData && (
                      <Bumbal
                        refetchDates={fetchDates}
                        slots={bumbalDates || []}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        refetchAmount={fetchAmount}
                      />
                    )}
                  </>
                )
              ) : (
                <>
                  {bumbalData && (
                    <Bumbal
                      refetchDates={fetchDates}
                      slots={bumbalDates || []}
                      selectedDate={selectedDate}
                      setSelectedDate={setSelectedDate}
                      refetchAmount={fetchAmount}
                    />
                  )}
                </>
              )
            ) : (
              <Bumbal
                refetchDates={() => {}}
                slots={[]}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                refetchAmount={fetchAmount}
              />
            )}
          </div>
        </div>
      </Card>
    </Container>
  );
};
export default NoAppointment;
